import { gql } from 'apollo-boost';

const chatListFetchTag = gql`
  query chatList($channel_data: Boolean!, $appointment_id:String) {
    followUpChatListPaginated(
      channel_data: $channel_data,
      appointment_id:$appointment_id,
      page_size: 1
    ) {
      data {
        id
      }
    }
  }
`;

const homeQueryTag = gql`
{
  vaccinationReminders{
    doctor{
      sex
      doctorID
      firstName
      lastName
      profile_pic
      speciality
      clinics{
        name
        contact
      }
    }
    patient{
      firstName
      lastName
    }
    dueVaccinations{
      vaccinationName
      dueDate
    }
  }

  pendingPayments{
    id
    status
    created_at
    sessionAppointment{
      appointmentDate
      appointmentTime
      reason
    }
    pricing_details{
      total
    }
    doctor{
      sex
      profile_pic
      speciality
      firstName
      lastName
      doctorID
    }
    patient{
      firstName
      lastName
    }
  }

  latestDoctorPatientVisit{
    doctor{
      sex
      firstName
      lastName
      doctorID
      speciality
      profile_pic
    }
    patient{
      firstName
      lastName
    }
    visitID
    dateTimeISO
  }

  followupReminders{
    doctor{
      firstName,
      lastName,
      profile_pic,
      doctorID,
      speciality
      sex
    }
    patient{
    firstName
    lastName
    }
    followUpDate
    visitID
    dateTimeISO
  }

  appointmentReminders{
   doctor{
     firstName
     lastName
     speciality
     doctorID
     profile_pic
     sex
   }
   patient{
     firstName
     lastName
     patientID
     sex
     dateOfBirth
     estimatedDOB
   }
   slotNumber
   arrivalTime
   teleconsultSession{
     channel_uuid
     sessionAppointment{
       appointmentDate
     }
   }
   appointmentID
   appointmentTime
   appointmentDate
   primaryConcern
   isTeleConsult
   clinic{
     address{
       latitude
       longitude
     }
   }
 }
}
`;
const cartSubscriptionTag = gql`
subscription cartUrl($visitID: String!,$pincode: Int) {
  medicineOrder(visitID: $visitID, pincode: $pincode) {
    type
    visitID
    cartLink
    message
  }
}
`;

export {
  chatListFetchTag,
  homeQueryTag,
  cartSubscriptionTag,
};